module.exports = __webpack_public_path__ + "static/media/Maestro-logo.b142cfdf.png";